import pages from './pages';

export default {
  Pages: pages,
};
